import { useQuery } from 'data-fetching-client';
import { GET_LIST_REFERENCES } from 'flow-doctor-lib/queries/ListQueries';
import { useMemo } from 'react';
const useListReferencesById = ({
  portalId,
  listId
}) => {
  const {
    data: listReferencesData,
    loading: listReferencesLoading,
    error: listReferencesError
  } = useQuery(GET_LIST_REFERENCES, {
    variables: {
      portalId,
      listId
    }
  });
  const dataToReturn = useMemo(() => {
    if (listReferencesData) {
      return listReferencesData.listReferences.reduce((acc, ref) => Object.assign({}, acc, {
        [ref.referenceType]: ref.referenceId
      }), {});
    }
    return {};
  }, [listReferencesData]);
  return {
    data: dataToReturn,
    loading: listReferencesLoading,
    error: listReferencesError
  };
};
export default useListReferencesById;